import LazyImage from "@/my_components/Common/LazyImage";
import Link from "next/link";
import React from "react";
import { useTranslation } from "react-i18next";

const slugify = (str) =>
  String(str)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/(^_|_$)/g, "");

const BlogAuthor = ({ author }) => {
  const { t } = useTranslation("blog");
  const { name, about, info, img, social } = author;
  const authorSlug = slugify(name);

  return (
    <>
      <div className="media">
        <div className="thumbnail">
          <Link href="#">
            <LazyImage
              src={img}
              width={105}
              height={105}
              alt={t("detail.authorImageAlt", "Author Images")}
            />
          </Link>
        </div>
        <div className="media-body">
          <div className="author-info">
            <h5 className="title">
              <Link className="hover-flip-item-wrapper" href="#">
                {name}
              </Link>
            </h5>
            <span className="b3 subtitle">{t(`authors.${authorSlug}.position`, about)}</span>
          </div>
          <div className="content">
            <p className="description">{t(`authors.${authorSlug}.info`, info)}</p>
            <ul className="social-icon social-default icon-naked justify-content-start">
              {social.map((socialItem, innerIndex) => (
                <li key={innerIndex}>
                  <Link href={socialItem.url}>
                    <i className={socialItem.icon}></i>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogAuthor;
